import { ProductId, ProductSku } from '../../store/types';
import { sendNeonEvent } from '../providers/Neon';
import {
  OnAfterCartDelete,
  OnAfterProductAdd,
  OnAfterProductDecrease,
  OnAfterProductIncrease,
  OnAfterRecommendationProductAdd
} from '../dispatchers';

type AddToCartTypes = 'add' | 'remove' | 'plus' | 'minus';
type AddToCartAliases = '' | 'recommend_target';

const addToCart = (
  id: number,
  type: AddToCartTypes,
  alias: AddToCartAliases
) => {
  sendNeonEvent({
    action: 'addCart',
    params: { id, type, alias }
  });
};

const updateCart = (cart: number[]) => {
  sendNeonEvent({ action: 'updateCart', params: { cart } });
};

OnAfterCartDelete.subscribe((ids) => {
  updateCart(ids.map(id => +id));
});
OnAfterProductAdd.subscribe(({ sku }) =>
  addToCart(+sku, 'add', '')
);
OnAfterProductIncrease.subscribe(({ sku }) =>
  addToCart(+sku, 'plus', '')
);
OnAfterProductDecrease.subscribe(({ sku }) =>
  addToCart(+sku, 'minus', '')
);
OnAfterRecommendationProductAdd.subscribe(({ sku }) =>
  addToCart(+sku, 'add', 'recommend_target')
);
